export default {
  stepNumber: {
    id: 'product_page_refurb_process_step_number',
    defaultMessage: 'Step {stepNumber}',
  },
}
